import { createSlice } from "@reduxjs/toolkit";

const publicSlice = createSlice({
  name: "Public",
  initialState: {
    containerTypes: [],
    fuelTypes: [],
    containerOptions: [],
    containerMaterials: [],

    countries: [],
    currencies: [],
    countryOptions: [],
  },
  reducers: {
    setContainerTypes(state, action) {
      state.containerTypes = [...action.payload];
    },

    setFuelTypes(state, action) {
      state.fuelTypes = [...action.payload];
    },

    setContainerOptions(state, action) {
      state.containerOptions = [...action.payload];
    },

    setContinerMaterials(state, action) {
      state.containerMaterials = action.payload;
    },

    setAllCountries(state, action) {
      state.countries = [...action.payload];
    },

    setAllCurrencies(state, action) {
      state.currencies = [...action.payload];
    },

    setCountryOptions(state, action) {
      state.countryOptions = action.payload;
    },
  },
});

export const publicSliceActions = publicSlice.actions;

export default publicSlice.reducer;
